import React from "react"
import { Container, Col, Row } from "reactstrap"
import { Link } from "../../components/button/Button"
import { Paragraph, TextBlock, TitleH2 } from "../../components/textBlock/TextBlock"
import { Section } from "../../layout/section/Section"


const CtaFour = (props) =>{
    return (
        <Section className ={props.className && props.className} id={props.id && props.id} >
            <Container>
                <Row className="justify-content-center text-center">
                    <Col xl="12" lg="9" md="9">
                        <TextBlock className="is-compact">
                            <TitleH2 className="pb-5">Need help implementing your Data-driven DE&amp;I Strategy?</TitleH2>
                            <br/>
                            <Paragraph className="pb-5">TEXpert AI can integrate your systems &amp; workflow to bring together the data you need for your strategy. <br/>Supporting you with data-collection, choice of metrics, intersectional analysis, monitoring and reporting enabled through its powerful unified analytics SaaS. </Paragraph>
                            <br/>
                            <ul className="btns-inline">
                                <li>
                                    <Link to="https://cal.com/texpertai/demo" target="_blank" rel="noreferrer" className="btn-lg btn-primary">Book a Demo</Link>
                                </li>
                            </ul>
                            <br/>
                        </TextBlock>
                    </Col>
                </Row>
            </Container>
        </Section>
    )
}

export default CtaFour
